export const mockData = {
  company: {
    name: "ShieldComply",
    tagline: "YOUR EMERGENCY COMPLIANCE PARTNER",
    logo: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/lcse5y7z_White_Back_-_With_SubTitle_for_EMAIL_SIGNATURE-removebg.png",
    phone: "0401 650 479",
    email: "claudia@shieldcomply.com.au",
    address: "Central Coast, NSW",
    serviceAreas: "Servicing Central Coast, Newcastle, Sydney, Hunter & NSW",
  },
  
  hero: {
    title: "Expert Emergency Management & Fire Safety Solutions",
    subtitle: "Safeguarding businesses across Central Coast, Newcastle, Sydney, Hunter and NSW with comprehensive emergency planning, fire safety training, and compliance services",
    cta: "Get a Free Consultation",
    image: "https://images.unsplash.com/photo-1633092228879-d6a88c22e7bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxmaXJlJTIwZXh0aW5ndWlzaGVyJTIwdHJhaW5pbmd8ZW58MHx8fHwxNzcwNzk5MzcwfDA&ixlib=rb-4.1.0&q=85"
  },
  
  services: [
    {
      id: 1,
      title: "Warden Training",
      description: "Essential training for businesses and building owners to enhance emergency preparedness. Our comprehensive program covers emergency response principles, evacuation procedures, communication strategies, and practical exercises. Empower your designated wardens with the knowledge to identify, respond, and act with confidence during all emergency situations.",
      icon: "Shield",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/6uot5n8d_Warden%20Hat.webp"
    },
    {
      id: 2,
      title: "Fire Safety & Extinguisher Training",
      description: "Comprehensive fire safety training combining awareness education with hands-on live fire extinguisher training. Learn fire prevention, hazard identification, and correct equipment use. Team members gain practical experience operating CO2 fire extinguishers with real fire scenarios in a controlled, safe environment. Our expert trainers ensure effective training that builds genuine confidence and ownership of fire safety responsibilities.",
      icon: "Flame",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/mp2ife47_Claudia%20Fire%20Training.jpg"
    },
    {
      id: 3,
      title: "Emergency Response Procedures",
      description: "Site-specific procedure manuals developed in accordance with Australian Standard AS 3745:2021 Planning For Emergencies In Facilities. We address your site-specific risks and establish effective response protocols. Safety isn't one-size-fits-all - we develop tailored procedures that suit your unique facility needs.",
      icon: "FileText",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/lsv8q280_Emergency%20Plan.webp"
    },
    {
      id: 4,
      title: "Evacuation Diagrams",
      description: "Site-specific evacuation diagrams designed and installed in accordance with Australian Standard AS 3745-2010. Unlike generic evacuation procedures, our detailed visual aids enhance clarity and understanding in an emergency. We assist from design through to installation, providing clear paths to safety.",
      icon: "MapPin",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/odnfbc8i_Evacuation%20diagram.webp"
    },
    {
      id: 5,
      title: "Trial Evacuations",
      description: "Test your Emergency Control Organisation (ECO) or wardens in a controlled environment before a real emergency occurs. We tailor the training for your site and needs, conducting realistic drills utilising smoke simulation to create authentic emergency conditions. Assess and improve your response times.",
      icon: "Users",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/jmdb61sq_Evac%20Man%20in%20Green.png"
    },
    {
      id: 6,
      title: "Compliance Consulting",
      description: "Expert guidance to ensure your organisation meets all emergency management and fire safety regulatory requirements. From assessment through to implementation, we provide end-to-end solutions tailored to your specific industry and facility needs.",
      icon: "CheckCircle",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/770otqbo_Compliance%20Consulting%20.webp"
    }
  ],
  
  industries: [
    {
      id: 1,
      title: "Aged Care Facilities",
      description: "Specialized emergency planning for aged care homes with vulnerable populations",
      icon: "Heart"
    },
    {
      id: 2,
      title: "Retirement Villages",
      description: "Tailored safety solutions for retirement living communities",
      icon: "Home"
    },
    {
      id: 3,
      title: "Commercial & Corporate",
      description: "Comprehensive emergency management for offices and commercial buildings",
      icon: "Building"
    },
    {
      id: 4,
      title: "Healthcare Facilities",
      description: "Critical emergency planning for hospitals and medical centers",
      icon: "Activity"
    },
    {
      id: 5,
      title: "Educational Institutions",
      description: "Safety solutions for schools, universities, and training facilities",
      icon: "GraduationCap"
    },
    {
      id: 6,
      title: "Industrial & Manufacturing",
      description: "High-risk environment emergency management and fire safety",
      icon: "Factory"
    }
  ],
  
  whyChooseUs: [
    {
      id: 1,
      title: "Expert Knowledge",
      description: "Deep expertise in emergency management, fire safety, and Australian compliance standards",
      icon: "Award"
    },
    {
      id: 2,
      title: "Tailored Solutions",
      description: "Every service is customized to your specific needs, risks, and operational requirements",
      icon: "Target"
    },
    {
      id: 3,
      title: "Hands-On Training",
      description: "Practical, engaging training that gives your team real-world skills and confidence",
      icon: "Zap"
    },
    {
      id: 4,
      title: "All Sectors Experience",
      description: "Proven track record across diverse industries from aged care to manufacturing",
      icon: "Briefcase"
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Josh",
      title: "General Manager",
      company: "The Springs Golf Course and Function Centre",
      review: "Claudia played a pivotal role in bringing The Springs Golf Course and Function Centre into full compliance. She developed comprehensive site-specific Emergency Response Procedures, produced clear and compliant evacuation diagrams, and the team also provided valuable guidance around the servicing and maintenance of our fire safety systems. Her expertise ensured our facility meets regulatory requirements while safeguarding all occupants."
    },
    {
      id: 2,
      name: "Gosford Cubby House",
      company: "",
      title: "",
      review: "Thank you so much for the most interactive fire training we have ever had. All the Educators said how much they learnt and so much fun. Just some feedback for you: One of the Educators came in the next morning and said she went straight to Bunnings after training and bought a fire blanket and an extinguisher and she saw another Educator there buying the same. So well done! They took everything that you said on board."
    },
    {
      id: 3,
      name: "Hayley Kilroy",
      title: "Director",
      company: "Little Cookies",
      review: "Claudia from Shield Comply was amazing! The team enjoyed the educational experience and learnt so much that we had never really though of in regard to fire safety."
    }
  ],
  
  trainingGallery: [
    {
      id: 1,
      client: "Bluewave Living",
      industry: "Healthcare & Aged Care",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/4n2oxrgo_Bluewave%20Living.jpg"
    },
    {
      id: 2,
      client: "Fenwicks Marina",
      industry: "Marine",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/ernygrb1_Boating.webp"
    },
    {
      id: 3,
      client: "Broadwater Court Retirement",
      industry: "Retirement Village",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/vynpo5as_Broadwater%20Court%20Retirement.jpg"
    },
    {
      id: 4,
      client: "Coast Shelter",
      industry: "Community",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/3lt8qrt8_Coast%20Shelter.jpg"
    },
    {
      id: 5,
      client: "Diggers",
      industry: "Hospitality",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/7g6fp36u_Diggers.jpg"
    },
    {
      id: 6,
      client: "Garden City Plastics",
      industry: "Manufacturing & Industrial",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/ejdurcfh_Garden%20City%20Plastics.jpg"
    },
    {
      id: 7,
      client: "Ibis Styles Hotel",
      industry: "Hospitality",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/xddrcdux_Ibis%20Styles%20Hotel.jpg"
    },
    {
      id: 8,
      client: "Lake Macquarie Yacht Club",
      industry: "Marine & Hospitality",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/p3i1ezbv_Lake%20Macquarie%20Yacht%20Club.jpg"
    },
    {
      id: 9,
      client: "PRP Diagnostic Imaging",
      industry: "Healthcare & Medical",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/fnp6xzlz_PRP.webp"
    },
    {
      id: 10,
      client: "Sherwin Williams",
      industry: "Commercial & Industrial",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/10uzm8dr_Sherwin%20Williams.webp"
    },
    {
      id: 11,
      client: "NAISDA",
      industry: "Education",
      image: "https://customer-assets.emergentagent.com/job_a4021837-3582-4ee7-b822-1cad7b5d2ac2/artifacts/l4i0brww_NAISDA.webp"
    },
    {
      id: 12,
      client: "Logan Group",
      industry: "Commercial Manufacturing",
      image: "https://customer-assets.emergentagent.com/job_a4021837-3582-4ee7-b822-1cad7b5d2ac2/artifacts/a5cr6on3_Logan%20Group.webp"
    },
    {
      id: 13,
      client: "Prok",
      industry: "Industrial Manufacturing",
      image: "https://customer-assets.emergentagent.com/job_a4021837-3582-4ee7-b822-1cad7b5d2ac2/artifacts/fcdgj3bk_Prok%20.webp"
    },
    {
      id: 14,
      client: "Warrah",
      industry: "Community",
      image: "https://customer-assets.emergentagent.com/job_a4021837-3582-4ee7-b822-1cad7b5d2ac2/artifacts/7zkkw7r1_Warrah.webp"
    },
    {
      id: 15,
      client: "Sweetwater Grove",
      industry: "Retirement Village",
      image: "https://customer-assets.emergentagent.com/job_shield-web-1/artifacts/xsk9pbd6_Sweetwater%20Grove.jpg"
    },
    {
      id: 16,
      client: "Little Miracles",
      industry: "Early Childhood Education",
      image: "https://customer-assets.emergentagent.com/job_a4021837-3582-4ee7-b822-1cad7b5d2ac2/artifacts/r561urc4_Little%20Miracles.webp"
    },
    {
      id: 17,
      client: "Evoke Projects",
      industry: "Architecture and Project Management",
      image: "https://customer-assets-agu9un31.emergentagent.net/job_a4021837-3582-4ee7-b822-1cad7b5d2ac2/artifacts/sdnty8xo_Evoke%20Projects.jpg"
    },
    {
      id: 18,
      client: "Mitre 10 Kincumber",
      industry: "Retail",
      image: "https://customer-assets-agu9un31.emergentagent.net/job_a4021837-3582-4ee7-b822-1cad7b5d2ac2/artifacts/rp7fyfy9_Mitre%2010%20Kincumber.jpg"
    }
  ],
  
  stats: [
    {
      number: "500+",
      label: "Organisations Served"
    },
    {
      number: "10,000+",
      label: "Staff Trained"
    },
    {
      number: "100%",
      label: "Compliance Success"
    },
    {
      number: "24/7",
      label: "Support Available"
    }
  ],
  
  serviceOptions: [
    "Fire Warden Training",
    "Fire Safety & Extinguisher Training",
    "Emergency Procedure Manuals",
    "Evacuation Diagrams",
    "Trial Evacuations",
    "Compliance Consulting",
    "Full Safety Assessment"
  ],
  
  onlineCourses: [
    {
      id: 1,
      title: "Warden Training",
      lookupKey: "warden_training",
      price: 89,
      duration: "60-90 minutes",
      description: "Comprehensive online training for emergency wardens covering all essential responsibilities and procedures.",
      modules: [
        {
          id: 1,
          title: "Role of the Warden under AS 3745-2010",
          description: "Understanding warden responsibilities, legal requirements, and Australian Standards compliance.",
          duration: "15-20 min"
        },
        {
          id: 2,
          title: "Alarms and Emergency Types",
          description: "Recognizing different alarm systems and responding to various emergency scenarios.",
          duration: "15-20 min"
        },
        {
          id: 3,
          title: "Evacuation Procedures and PEEPs",
          description: "Implementing effective evacuation procedures and Personal Emergency Evacuation Plans.",
          duration: "15-20 min"
        },
        {
          id: 4,
          title: "Communication and Reporting",
          description: "Emergency communication protocols and proper incident reporting procedures.",
          duration: "15-20 min"
        }
      ]
    },
    {
      id: 2,
      title: "Chief Warden Training",
      lookupKey: "chief_warden_training",
      price: 119,
      duration: "90-120 minutes",
      description: "Advanced training for Chief Wardens leading Emergency Control Organisations (ECO).",
      modules: [
        {
          id: 1,
          title: "Leading the ECO",
          description: "Organizational structure, team leadership, and establishing command during emergencies.",
          duration: "20-25 min"
        },
        {
          id: 2,
          title: "Command and Decision-Making",
          description: "Critical decision-making under pressure and establishing incident command.",
          duration: "20-25 min"
        },
        {
          id: 3,
          title: "Coordinating the Response",
          description: "Managing multiple wardens, liaising with emergency services, and resource allocation.",
          duration: "25-30 min"
        },
        {
          id: 4,
          title: "After the Emergency",
          description: "Post-incident procedures, debriefing, reporting, and annual evacuation exercise requirements.",
          duration: "25-30 min"
        }
      ]
    },
    {
      id: 3,
      title: "Fire Awareness Training",
      lookupKey: "fire_awareness_training",
      price: 59,
      duration: "60-75 minutes",
      description: "Essential fire safety awareness for all staff members covering prevention and emergency response.",
      modules: [
        {
          id: 1,
          title: "Fire Fundamentals",
          description: "Understanding the fire triangle, combustion principles, and how fires spread.",
          duration: "10-15 min"
        },
        {
          id: 2,
          title: "Prevention and Housekeeping",
          description: "Identifying fire hazards, workplace housekeeping, and preventive measures.",
          duration: "12-15 min"
        },
        {
          id: 3,
          title: "Lithium-Ion Battery Dangers",
          description: "Understanding risks associated with lithium-ion batteries and safe handling procedures.",
          duration: "10-12 min"
        },
        {
          id: 4,
          title: "Extinguishers and PASS Technique",
          description: "Types of fire extinguishers, proper selection, and the PASS technique for operation.",
          duration: "12-15 min"
        },
        {
          id: 5,
          title: "RACE Emergency Response",
          description: "Rescue, Alarm, Contain, Extinguish/Evacuate - essential emergency response protocol.",
          duration: "12-15 min"
        }
      ]
    }
  ]
};
